import { WorklistTask } from '@strata/react-worklist';

import { fmhNpiAPI, WORKLIST_API_URL } from 'api/APIBase';

export async function getWorklistTasks() {
    const url = `${WORKLIST_API_URL}/tasks`;
    return fmhNpiAPI({ url }).get().json<WorklistTask[] | null>();
}

export async function getWorklistToDoTaskCount() {
    const url = `${WORKLIST_API_URL}/tasks/count`;
    return fmhNpiAPI({ url }).get().json<{ task_count: number }>();
}
